export default __webpack_public_path__ + "static/media/accommodation.85e12f21.svg";